define('modules/base/models/auth.password.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var AuthPasswordModel = BaseModel.extend({
        debugName: 'DefaultCredentialsModel',
        serviceRoot:'una/v1/',
        base: 'auth/password',
        requiresSpecifiedHost: false
    });
    return AuthPasswordModel;
});

